export default __webpack_public_path__ + "static/media/products.e37dd831.svg";